import React from 'react';
import queryString from 'query-string';
import get from 'lodash/get';
import { amplitudeLogEvent } from '@flow/libs/client-analytics/amplitude';
import { useSelector } from 'react-redux';
import { getGuestToken } from '@flow/libs/agreement/selectors';
import { postSignupGuestConversion } from '@flow/libs/oneflow-client/signup';
import noop from 'lodash/noop';

import ModalForm from '@app/hocs/modal-form';

import { T } from '@app/components/translation';

import GuestConversionModalBody from './guest-conversion-modal-body';
import GuestConversionModalActions from './guest-conversion-modal-actions';

type FormData = {
  email: string;
  password: string;
};

type GuestConversionModalProps = {
  agreementId: number;
  onClose?: () => void;
  isSecondStep?: boolean;
  isOpen?: boolean;
  modalKey: string;
  myParticipant: {
    id: number;
    fullName: string;
    email: string;
  };
  myParticipantCompany: {
    id: number;
    name: string;
  };
};

export const GuestConversionModal: React.FC<GuestConversionModalProps> = ({
  agreementId,
  myParticipant,
  myParticipantCompany,
  onClose,
  isSecondStep,
  isOpen,
  modalKey,
}) => {
  const guestToken = useSelector((state) => getGuestToken(state));

  const [modalIsOpen, setModalIsOpen] = React.useState(isOpen || false);

  // Actions
  const handleOpen = () => {
    const parsedSearch = queryString.parse(window.location.search);
    const modalQuery = get(parsedSearch, 'm');

    amplitudeLogEvent('Open Guest Conversion Modal', {
      location: modalQuery ? 'immediate' : 'sign-flow',
    });
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setModalIsOpen(false);
  };

  const validateIfChecked = (value: boolean) => {
    if (value !== true) {
      return true;
    }
    return undefined;
  };

  const handleSubmit = async ({ password }: FormData) => {
    const { id } = myParticipant;
    await postSignupGuestConversion({
      agreementId,
      participantId: id,
      password,
      guestToken,
    });

    return setTimeout(() => window.location.replace('/'), 0);
  };

  return (
    <ModalForm
      title={
        <T
          _str="Document signing"
          _comment="Modal title when the signing has been finished by all parties."
        />
      }
      body={
        <GuestConversionModalBody
          fullName={myParticipant.fullName}
          email={myParticipant.email}
          companyName={myParticipantCompany.name}
          isSecondStep={isSecondStep}
          validateIfChecked={validateIfChecked}
        />
      }
      actions={({ formProps }: any) => (
        <GuestConversionModalActions
          isSubmitting={formProps?.submitting}
          isInValid={formProps?.invalid}
          isValidating={formProps?.validating}
          handleClose={handleClose}
          handleSubmit={formProps?.handleSubmit}
        />
      )}
      formState={{}}
      resetFormState={noop}
      onSubmit={handleSubmit}
      isOpen={modalIsOpen}
      onClose={handleClose}
      onOpen={handleOpen}
      modalKey={modalKey}
    >
      {() => <></>}
    </ModalForm>
  );
};
